import { Injectable } from '@angular/core';

interface RichTextEditState {
  id: number;
  content: string;
}

@Injectable({ providedIn: 'root' })
export class RichTextEditorService {
  private currentEdit: RichTextEditState | null = null;
  private isDirty = false;

  setCurrentEdit(newEdit: RichTextEditState) {
    if (
      this.currentEdit &&
      (this.currentEdit.id !== newEdit.id)
    ) {
      this.clear();
    }

    this.currentEdit = newEdit;
    this.isDirty = true;
  }

  getCurrentEdit(): RichTextEditState | null {
    return this.currentEdit;
  }

  hasPendingChanges(): boolean {
    return this.isDirty && !!this.currentEdit;
  }

  markAsSaved() {
    this.isDirty = false;
  }

  clear() {
    this.currentEdit = null;
    this.isDirty = false;
  }
}
